import React from 'react';
import axios from "axios";
import { BUBBLE_LOADING, META_FACEBOOK, BREADCRUMB_SCHEMA } from '../../constants/FrontEndConstant';
import { LANGUAGE_CODE, API_URL, META_TITLE_APPEND } from '../../constants/DotEnv';
import AvvHeader from '../subPageHeader/SubPageHeader';
class Avv extends React.Component {
    constructor() {
        super();
        this.state = {
            avvdata: {},
            loading: 'false',
            dataLength: '',
            title: ''
        }
    }
    componentWillUnmount() {
        setTimeout(() => {
            window.setOgTag(META_FACEBOOK['og_title'], META_FACEBOOK['og_description'], META_FACEBOOK['og_image'], META_FACEBOOK['og_url'])
            window.removeSchema();
        }, 100)
    }
    componentDidMount() {
        this.scrollUpFunction();
        this.avvContent();
        setTimeout(() => {
            try {
                const avvSchema = (BREADCRUMB_SCHEMA && BREADCRUMB_SCHEMA['avv']) ? BREADCRUMB_SCHEMA['avv'] : null;
                if (avvSchema && avvSchema['schema2']) {
                    var schema2 = window.positionCreate(
                        avvSchema['schema2']['position'],
                        avvSchema['schema2']['url'],
                        avvSchema['schema2']['name']
                    );
                    var schemaObject = window.schemaObj(BREADCRUMB_SCHEMA['schema1'], schema2, avvSchema['schema3'] || {});
                    window.setSchema(schemaObject);
                }
            } catch (e) {
                // No-op: schema is not critical for page rendering
            }
        }, 100)
    }
    scrollUpFunction = () => {
        /**for scrolling up page */
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        let count = document.querySelector('.navbar-toggler')!=null?document.querySelector('.navbar-toggler').className.indexOf("collapsed"):0;
        if (count === -1) {
            document.querySelector('.navbar-collapse').classList.remove('show');
            document.querySelector('header').classList.remove("header_collapse");
            document.querySelector('.navbar-toggler').setAttribute("aria-expanded", false);
        }
    }
    avvContent = () => {
        this.setState({ loading: 'true' })
        let self = this;
        let avvdata = '';
        let dataLength = '';
        let title = '';
        let meta_title = '';
        let meta_description = '';
        let meta_keywords = '';
        let og_title = '';
        let og_description = '';
    let og_image = '';
    // Fetch AVV by slug to avoid environment-specific IDs
    axios.get(API_URL + '/cms/getCmsBySlug/avv/' + LANGUAGE_CODE)
            .then((response) => {
                avvdata = (response && response.data && response.data.success && response.data.success.cms) ? response.data.success.cms : {};
                dataLength = Object.keys(avvdata).length;
                if (dataLength > 0) {
                    title = avvdata['title'];
                    meta_title = avvdata['title'] + META_TITLE_APPEND;
                    meta_description = avvdata['metadescription'];
                    meta_keywords = avvdata['metakeyword'];
                    og_title = avvdata['title'] + META_TITLE_APPEND;
                    og_description = avvdata['metadescription'];
                    og_image = META_FACEBOOK['og_image'];
                    window.setMeta({ "description": meta_description, "keywords": meta_keywords });
                    window.setOgTag(og_title, og_description, og_image, window.location.href)
                    window.setDocumentTitle(meta_title)
                    self.setState({ loading: 'false', avvdata, dataLength, title })
                } else {
                    // No CMS data found -> trigger 404 via SubPageHeader
                    self.setState({ loading: 'false', avvdata: {}, dataLength: 0, title: '' })
                }
            })
            .catch((error) => {
                // Request failed -> trigger 404 via SubPageHeader
                self.setState({ loading: 'false', avvdata: {}, dataLength: 0, title: '' })
            })
    }
    render() {
        let length = Object.keys(this.state.avvdata).length
        let avvdata = this.state.avvdata;
        return (
            <main>
                {(this.state.loading === 'true') ?
                    BUBBLE_LOADING
                    : null
                }
                <AvvHeader data={avvdata} title={this.state.title} dataLength={this.state.dataLength} />
                {(length > 0 && this.state.loading === 'false') ?
                    <section className="section-blog">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-md-12">
                                    <div className="blog-lising">
                                        <div dangerouslySetInnerHTML={{ __html: avvdata['content'] }}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    : null
                }
            </main>
        );
    }
}
export default Avv;